import React from 'react';
import LeadershipChrome from '@/components/LeadershipChrome';
import LeadershipPageHeader from '@/components/LeadershipPageHeader';
import { LEADERSHIP_CONTENT } from '@/config/leadershipLayout';

/** FIC shell with chrome + light page title (for screens that do not own a header). */
export default function LeadershipPageShell({ title, subtitle, children, actions, headerActions }) {
  return (
    <LeadershipChrome actions={actions} homeHref="/management" roleLabel="Leadership" showLeadershipMenu>
      <div className={LEADERSHIP_CONTENT}>
        {(title || subtitle) ? (
          <LeadershipPageHeader title={title} subtitle={subtitle} actions={headerActions} />
        ) : null}
        {children}
      </div>
    </LeadershipChrome>
  );
}
